// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d21c104","998":"698365e8"}[chunkId] + ".chunk.js";
};